import React, { FC, useMemo } from 'react';
import { TimePicker } from 'components/TimePicker';
import { useFormContext, Controller } from 'react-hook-form';
import moment from 'moment';
import { isIE } from 'react-device-detect';

export interface TimePickerProps {
  name: string
  defaultValue?: any
  validate: (any) => boolean
  disabled?: boolean
}

export const ControlledTimePicker: FC<TimePickerProps> = ({
  name, validate, defaultValue, disabled,
}) => {
  const { control } = useFormContext();

  const className = useMemo(() => {
    let sub = '';
    if (isIE) {
      sub += 'rc-time-picker-IE ';
    }
    if (disabled) {
      sub += 'rc-time-picker-disabled ';
    }
    return sub;
  }, []);

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value }) => (
        <TimePicker
          className={className}
          name={name}
          popupClassName="event-template-preview"
          allowEmpty={false}
          value={value ? moment(value, 'HH:mm') : moment()}
          showSecond={false}
          onChange={(time) => {
            onChange(time.format('HH:mm'));
          }}
          use12Hours
          disabled={disabled}
        />
      )}
      rules={{
        required: true,
        validate,
      }}
    />
  )
};
